<template>
  <v-form v-model="valid" ref="mainForm">
    <CarteInfosOrganisation :societe="sas.societe" class="mb-6" />
    <CatalogueLive
      code="societe_modification_ouinon"
      v-model="sasSociete.souhaitezVousMettreAJourLesInformationsDeLaSociete"
      :live="liveSociete(25930)"
    />

    <TextFieldLive :opqIf="conditionModification" code="societe_nom" v-model="sasSociete.nomDeLaSociete" :live="liveSociete(25905)" />
    <CatalogueLive
      :opqIf="conditionModification"
      code="societe_forme_juridique"
      v-model="sasSociete.formeJuridique"
      ref="formeJuridique"
      :live="liveSociete(25906)"
      :filter="(fd) => fd.code !== sas.societe.codeFormeJuridique"
    />
    <v-btn v-if="sasSociete.formeJuridique" text color="primary" @click="$refs.formeJuridique.clear()"
      ><ressource code="annuler_changemnent_forme_juridique"
    /></v-btn>
    <FileInput
      code="societe_certificat_constitution"
      :file="sasSociete.statutsConstitutifsDeLaSociete"
      :live="liveSociete(25917)"
      :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
      :opqIf="conditionStatutsConstitutifsDeLaSociete"
    />
    <FileInput
      code="societe_contrat"
      :file="sasSociete.contratDeLaSociete"
      :live="liveSociete(25918)"
      :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
      :opqIf="conditionContratDeLaSociete"
    />
    <FileInput
      code="certificat_req"
      :file="sasSociete.certificatDeModificationDuRegistreDEntrepriseDuQuebec"
      :live="liveSociete(25937)"
      :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
      :opqIf="conditionReq"
    />

    <TextFieldLive
      :opqIf="conditionModification"
      code="societe_neq"
      v-model="sasSociete.numeroDEntrepriseDuQuebec"
      :live="liveSociete(25908)"
      @eudo-updated="checkIfNeqExists"
      :disabled="neqLoading"
      :loading="neqLoading"
    />
    <v-alert type="error" text v-show="conditionModification && organisationFound">
      <Ressource code="neq_existant" />
    </v-alert>
    <v-checkbox class="list_counter_validator my-2 ml-6 p-0" :input-value="organisationFound" :rules="[(v) => !v || '']"> </v-checkbox>

    <FileInput
      code="societe_certificat_fusion"
      :file="sasSociete.statutsDeFusionDeLaSociete"
      :live="liveSociete(25938)"
      :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
      :opqIf="conditionStatutsFusionDeLaSociete"
    />
    <CatalogueLive
      :opqIf="conditionModification"
      code="demenagement_adresse_oui_non"
      v-model="sasSociete.declarerLaModificationAdresse"
      :live="liveSociete(25943)"
    />

    <TextFieldLive
      :opqIf="conditionModificationAdresse"
      code="societe_adresse_ligne_1"
      v-model="sasSociete.adresseLigne1"
      :live="liveSociete(25910)"
      :ref="getId('adresse', sasSociete)"
      :id="getId('adresse-field', sasSociete)"
    />
    <TextFieldLive
      :opqIf="conditionModificationAdresse"
      code="societe_adresse_ligne_2"
      v-model="sasSociete.adresseLigne2"
      :live="liveSociete(25911)"
      :ref="getId('completementDAdresse', sasSociete)"
    />
    <TextFieldLive
      :opqIf="conditionModificationAdresse"
      code="societe_ville"
      v-model="sasSociete.ville"
      :live="liveSociete(25912)"
      :ref="getId('ville', sasSociete)"
    />
    <TextFieldLive
      :opqIf="conditionModificationAdresse"
      code="societe_codepostal"
      v-model="sasSociete.codePostal"
      :live="liveSociete(25913)"
      :ref="getId('codePostal', sasSociete)"
    />
    <CatalogueLive
      :opqIf="conditionModificationAdresse"
      code="societe_province"
      v-model="sasSociete.province"
      :live="liveSociete(25907)"
      :filter="(fd) => fd.code === 'QC'"
      :ref="getId('province', sasSociete)"
    />
    <CatalogueLive
      :opqIf="conditionModificationAdresse"
      code="societe_pays"
      v-model="sasSociete.pays"
      :live="liveSociete(25914)"
      :filter="(fd) => fd.code === 'CA'"
      :ref="getId('pays', sasSociete)"
    />
    <TextFieldLive :opqIf="conditionModificationAdresse" code="societe_telephone" v-model="sasSociete.telephone" :live="liveSociete(25915)" />
    <TextFieldLive :opqIf="conditionModificationAdresse" code="societe_telecopieur" v-model="sasSociete.telecopieur" :live="liveSociete(25916)" />
    <DatePickerLive
      :opqIf="conditionModification"
      code="societe_date_modification"
      v-model="sasSociete.dateDebutActivite"
      :live="liveSociete(25936)"
    />
  </v-form>
</template>

<script>
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import PosteCanada from "@/mixins/PosteCanada"
import { NeqExistsForAnotherOrganisation } from "@/plugins/services/organisations"
import Ressource from "@/components/ui/Ressource.vue"
import CarteInfosOrganisation from "@/components/form_parts/CarteInfosOrganisation.vue"
export default {
  mixins: [CataloguesHelpers, DatesHelpers, StepFormWithValidation, PosteCanada],
  components: { Ressource, CarteInfosOrganisation },
  props: {
    sas: { type: Object }
  },
  mounted() {
    this.checkIfNeqExists()
    if (this.conditionModification && this.conditionModificationAdresse) {
      this.addPosteCanadaConfig(this.sasSociete)
    }
  },
  watch: {
    conditionModificationAdresse(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.addPosteCanadaConfig(this.sasSociete)
        })
      }
    }
  },
  data() {
    return {
      neqLoading: false,
      organisationFoundModal: false,
      organisationFound: false,
      loadPosteCanadaOnMount: false,
      prefixPosteCanada: "societe_modification"
    }
  },
  computed: {
    sasSociete() {
      return this.sas.sasSociete
    },
    conditionStatutsConstitutifsDeLaSociete() {
      return this.getCatalogueCodeById("328", this.sas.sasSociete.formeJuridique) === "SPA"
    },
    conditionStatutsFusionDeLaSociete() {
      return !!this.sasSociete.numeroDEntrepriseDuQuebec
    },
    conditionReq() {
      return !!this.sasSociete.nomDeLaSociete || !!this.sasSociete.formeJuridique
    },
    conditionContratDeLaSociete() {
      return this.getCatalogueCodeById("328", this.sas.sasSociete.formeJuridique) === "SENCRL" && this.sas.societe.codeFormeJuridique !== "SENCRL"
    },
    conditionModification() {
      return this.estOui(this.sas.sasSociete.souhaitezVousMettreAJourLesInformationsDeLaSociete)
    },
    conditionModificationAdresse() {
      return this.estOui(this.sas.sasSociete.declarerLaModificationAdresse)
    }
  },
  methods: {
    liveSociete(cle) {
      return { endpoint: "sas-societe", cle: cle, fileId: this.sasSociete.id }
    },
    checkIfNeqExists() {
      this.neqLoading = true
      NeqExistsForAnotherOrganisation(this.sasSociete.numeroDEntrepriseDuQuebec, this.$route.query.organisationId)
        .then((res) => {
          this.organisationFoundModal = res.data.found
          this.organisationFound = res.data.found
        })
        .finally(() => {
          this.neqLoading = false
        })
    },
    viderFormeJuridique() {
      this.$refs.formeJuridique.clear()
    }
  }
}
</script>

<style></style>
